import { render, staticRenderFns } from "./ManageTableLib.vue?vue&type=template&id=27e6a201&scoped=true&"
import script from "./ManageTableLib.vue?vue&type=script&lang=js&"
export * from "./ManageTableLib.vue?vue&type=script&lang=js&"
import style0 from "./ManageTableLib.vue?vue&type=style&index=0&id=27e6a201&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e6a201",
  null
  
)

export default component.exports